export default {"src":"/_next/static/media/cube.cb1ae2fb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};